import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import theme from '@ecp/common/src/style/theme/default';
import { FlexBox, FlexBoxATag } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

import RankRealTimeDelta from '@fo-components/display/RankRealTimeDelta';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

const RealTimeBox = styled(FlexBox)`
  min-height: 50px;
  align-items: flex-start;
`;

const RealTimeListWrapper = styled(FlexBox)`
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 203px;
`;

const RealTimeWrapper = styled(FlexBox)`
  justify-content: space-between;
  &:nth-child(odd) {
    padding-right: 10px;
    ${({ hasBorder }) => (hasBorder ? `border-right: 1px solid ${theme.color.line.basic}` : '')};
  }

  &:nth-child(even) {
    padding-left: 10px;
  }
`;

const SearchRealTimeList = ({ list, handleSearch }) => {
  const firstTierList = useMemo(() => {
    return list?.slice(0, 5);
  }, [list]);
  const secondTierList = useMemo(() => {
    return list?.slice(5, 10);
  }, [list]);

  return (
    <>
      <RealTimeBox>
        <RealTimeListWrapper>
          {firstTierList?.map(({ ranking, title, delta }, index) => (
            <Row key={ranking}>
              <TextBox width={'10px'} size={theme.font.size.$14} weight={theme.font.weight.medium}>
                {`${ranking}`}
              </TextBox>
              <RealTimeWrapper key={index} hasBorder={firstTierList?.length > 1} flex={1}>
                <TextBox
                  ellipsis
                  size={theme.font.size.$12}
                  weight={theme.font.weight.demiLight}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSearch(title);
                  }}
                >
                  {title}
                </TextBox>
                <RankRealTimeDelta rankDelta={delta} />
              </RealTimeWrapper>
            </Row>
          ))}
        </RealTimeListWrapper>
        <Spacing left={34} />
        <RealTimeListWrapper>
          {secondTierList?.map(({ ranking, title, delta }, index) => (
            <RowRight key={ranking}>
              <TextBox width={'10px'} size={theme.font.size.$14} weight={theme.font.weight.medium}>
                {`${ranking}`}
              </TextBox>
              <RealTimeWrapper key={index} hasBorder={secondTierList?.length > 1} flex={1}>
                <TextBox
                  ellipsis
                  size={theme.font.size.$12}
                  weight={theme.font.weight.demiLight}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSearch(title);
                  }}
                >
                  {title}
                </TextBox>
                <RankRealTimeDelta rankDelta={delta} />
              </RealTimeWrapper>
            </RowRight>
          ))}
        </RealTimeListWrapper>
      </RealTimeBox>
    </>
  );
};

const Row = styled(FlexBoxATag)`
  width: 100%;
  padding-bottom: 5px;

  &:last-child {
    padding-bottom: 0;
  }
`;

const RowRight = styled(FlexBoxATag)`
  width: 100%;
  padding-bottom: 5px;

  &:last-child {
    padding-bottom: 0;
  }
`;
export default SearchRealTimeList;

SearchRealTimeList.propTypes = {
  list: PropTypes.array,
  handleSearch: PropTypes.func,
};
